export default __webpack_public_path__ + "static/media/im.3d2e63e1.svg";